import {PlatformNavbarMenuItem} from "@flexinet/ui-components";
import {
    AiOutlineAppstore,
    AiOutlineBook,
    AiOutlineBuild,
    AiOutlineCamera,
    AiOutlineCloudServer,
    AiOutlineDashboard,
    AiOutlineGroup,
    AiOutlineHome,
    AiOutlineLogin,
    AiOutlinePartition,
    AiOutlineSliders,
    AiOutlineThunderbolt,
    AiOutlineTool,
    AiOutlineWallet
} from 'react-icons/ai'
import {rbacActions} from "../../../config/rbac/actions";
import config from "../../../config";

export const getMenuItems = () => {
    return [
        {
            id: 'dashboard',
            link: '/dashboard',
            label: 'Dashboard',
            icon: <AiOutlineHome/>,
            rbac: rbacActions.ViewDashboard,
        }, {
            id: 'accounts',
            link: '/accounts',
            label: 'Accounts',
            icon: <AiOutlineWallet/>,
            rbac: rbacActions.ListAccounts,
        }, {
            id: 'users-group',
            link: '/users',
            label: 'Directory',
            icon: <AiOutlineGroup/>,
            rbac: 'ListUsers',
            defaultOpened: false,
            links: [{
                id: 'users',
                link: '/users',
                label: 'Users',
                icon: <AiOutlineLogin/>,
                rbac: rbacActions.ListUsers,
            }]
        }, {
            id: 'organizations',
            link: '/organizations',
            label: 'Organizations',
            icon: <AiOutlineCloudServer/>,
            rbac: rbacActions.ListOrganizations,
        }, {
            id: 'applications',
            link: '/applications',
            label: 'Applications',
            icon: <AiOutlineAppstore/>,
            rbac: rbacActions.ListApplications,
        }, {
            id: 'workflows-group',
            link: '/playbooks',
            label: 'Workflows',
            icon: <AiOutlinePartition/>,
            rbac: rbacActions.ListPlaybooks,
            defaultOpened: false,
            links: [{
                id: 'playbooks',
                link: '/playbooks',
                label: 'Playbooks',
                icon: <AiOutlineBook/>,
                rbac: rbacActions.ListPlaybooks,
            }, {
                id: 'executions',
                link: '/executions',
                label: 'Executions',
                icon: <AiOutlineThunderbolt/>,
                rbac: rbacActions.ListExecutions,
            }]
        }, {
            // FNP-1636: pipelines, code pipelines, repositories and account
            // groups moved to the DevOps application. One link replaces the
            // group. No `rbac`: the DevOps app enforces its own permissions
            // (flexinet-devops-avp-infra), and the Console's store never
            // declared those actions.
            id: 'devops-app',
            href: config.platform.devops,
            label: 'DevOps',
            icon: <AiOutlineBuild/>,
        }, {
            id: 'application-screenshots-group',
            link: '/application-screenshots',
            label: 'Tools',
            icon: <AiOutlineTool/>,
            rbac: rbacActions.ListApplicationScreenshots,
            defaultOpened: false,
            links: [{
                id: 'application-screenshots',
                link: '/application-screenshots',
                label: 'Screenshots',
                icon: <AiOutlineCamera/>,
                rbac: rbacActions.ListApplicationScreenshots,
            }]
        },
        {
            // FNP-891 / FNP-893: platform-wide operational controls. Top-level and
            // always present — the whole point of this module is that the controls
            // (including the ones not wired up yet) are visible rather than living
            // only in a parameter store nobody remembers.
            id: 'platform-controls',
            link: '/platform-controls',
            label: 'Platform Controls',
            icon: <AiOutlineSliders/>,
            rbac: rbacActions.ListPlatformControls,
        }, {
            id: 'analytics',
            link: '/analytics',
            label: 'Analytics',
            icon: <AiOutlineDashboard/>,
            rbac: rbacActions.ListUsers,
        }] as PlatformNavbarMenuItem[];

};

/**
 * Whether a top-level menu item renders for a user with these allowed actions.
 *
 * An item that names no `rbac` always renders. That is how a link out to
 * another application works (FNP-1636, the DevOps link): the target app
 * enforces its own permissions, and the Console's policy store has no action
 * for it. An item that names an action renders only when the user holds it.
 */
export const isMenuItemVisible = (
    item: PlatformNavbarMenuItem,
    allowedActions: string[],
): boolean => !item.rbac || allowedActions.includes(item.rbac);
